/** Tela de saída para a sessão que não alcança nenhuma tela do menu.
 *
 *  Existe por causa de um caso real e não hipotético: com o gate de leitura ligado,
 *  um usuário pode ficar sem nenhuma permissão de módulo, seja por revogação, seja
 *  por ter sido criado antes de o formulário pré-selecionar o conjunto do papel.
 *  Sem esta tela, `homePathFor` devolveria um caminho gateado, o PermissionGate
 *  mandaria de volta para a home, e o navegador entraria em laço.
 *
 *  Não é gateada por permissão nenhuma, de propósito: é o piso.
 */
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'
import { ShieldOff } from 'lucide-react'
import { useAuth } from '@/core/auth/useAuth'
import { useI18n } from '@/core/i18n/useI18n'
import { LEAF_RADIUS_SM } from '@/styles/theme'

export function SemAcessoPage() {
  const { t } = useI18n()
  const { user, logout } = useAuth()

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: { xs: 4, sm: 8 } }}>
      <Card sx={{ p: { xs: 3, sm: 4 }, maxWidth: 520, borderRadius: LEAF_RADIUS_SM }}>
        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', mb: 2 }}>
          <ShieldOff size={22} strokeWidth={2} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {t('auth.semAcesso.titulo')}
          </Typography>
        </Box>

        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
          {t('auth.semAcesso.explicacao')}
        </Typography>

        {user?.email && (
          <Box sx={{ mt: 2.5 }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
              {t('auth.semAcesso.contaRotulo')}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              {user.email}
            </Typography>
          </Box>
        )}

        <Box sx={{ mt: 3, display: 'flex', gap: 1 }}>
          <Button variant="outlined" size="small" onClick={() => window.location.reload()}>
            {t('auth.semAcesso.recarregar')}
          </Button>
          <Button variant="text" size="small" color="inherit" onClick={logout}>
            {t('auth.semAcesso.sair')}
          </Button>
        </Box>
      </Card>
    </Box>
  )
}
